module.exports = __webpack_public_path__ + "catalog/items/bathroom/Rounded-bath/Rounded-bath.svg";